import _ from 'lodash';

export function stopPropagation(fn) {
  return event => {
    event.stopPropagation();
    if (fn) return fn(event);
  };
}

export function preventDefault(fn) {
  return event => {
    event.preventDefault();
    if (fn) return fn(event);
  };
}

export function ignoreEnter(fn) {
  return event => {
    if (event.key === 'Enter') {
      event.preventDefault();
      if (fn) return fn(event);
    }
  };
}

export function debounceEvent(...args) {
  const debounced = _.debounce(...args);

  return e => {
    e.persist();
    return debounced(e);
  };
}
